<template>
  <div id="main-container" class="text-initial main-content">
    <div id="title">
      <h1>{{ $t("settings.title") }}</h1>
    </div>
    <div class="input mt-5">
      <label>{{ $t("utils.table.name") }}</label>
      <b-form-input v-model="name" />
    </div>
    <div id="change-password" class="mt-5">
      <h2>{{ $t("settings.change-password.title") }}</h2>
      <div id="password" class="mt-4">
        <div class="input">
          <label>{{ $t("settings.change-password.current-label") }}</label>
          <b-input type="password" v-model="password" />
        </div>
        <div class="input mt-2">
          <label>{{ $t("settings.change-password.new-label") }}</label>
          <b-input type="password" v-model="newPassword" />
        </div>
      </div>
    </div>
    <div id="notification-container" class="d-flex flex-column mt-5">
      <div>
        <h2>{{ $t("settings.notifications.title") }}</h2>
        <h3 v-html="$t('settings.notifications.description')" class="mt-3"></h3>
        <div id="notification" class="mt-4">
          <b-input
            v-model="emails"
            :placeholder="$t('settings.notifications.placeholder')"
          />
        </div>
      </div>
      <div id="save-button">
        <LoadingButton
          :text="$t('utils.save')"
          :classes="['btn-primary', 'w-100', 'mt-4']"
          :loading="loading"
          @click="saveData"
        />
      </div>

      <div class="error-container mt-2">
        <MessageBanner :message="error" :type="'error'" v-if="error !== ''" />
      </div>
    </div>
    <div id="support-container" class="mt-5">
      <h2>{{ $t("settings.support.title") }}</h2>
      <h3 v-html="$t('settings.support.description')" class="mt-3"></h3>
    </div>
  </div>
</template>

<script>
import MeService from "@/services/me";
import SpaceService from "@/services/space";

export default {
  data() {
    return {
      name: "",
      password: "",
      newPassword: "",
      emails: "",
      loading: false,
      error: "",
      currentUser: ""
    };
  },
  methods: {
    async saveData() {
      this.loading = true;
      this.success = false;
      this.error = "";

      try {
        if (this.name) {
          const body = {
            personalData: {
              name: this.name
            }
          };

          const { data: updatedUser } = await MeService.updateCurrentUser(body);

          this.$store.dispatch("currentUser/update", { user: updatedUser });
        }

        if (this.emails) {
          const body = {
            notify: {
              emails: this.emails.split(",")
            }
          };

          await SpaceService.updateSpace(this.currentUser.spaces[0], body);
        }

        if (this.password && this.newPassword) {
          await MeService.newPassword(this.password, this.newPassword);
          this.$store.dispatch("currentUser/logout");
        }
      } catch (error) {
        this.error = error.response.data.message;

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    },

    async getNotifyEmails() {
      const { data } = await SpaceService.getSpaceById(
        this.currentUser.spaces[0]
      );

      this.emails = data.notify.emails.join(",");
    }
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "");
    this.$store.dispatch("sidebar/setAction", "published");

    this.currentUser = this.$store.getters["currentUser/user"];
    this.name = this.currentUser.name;

    this.getNotifyEmails();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";
@import "src/assets/scss/colors";
@import "src/assets/scss/variables";
@import "src/assets/scss/buttons";

#main-container {
  margin-left: 30px;
}

#title {
  h1 {
    font-family: $mulish;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.3px;
    color: #252733;
  }
}

#change-password {
  h2 {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: #252733;
  }
}

.error-container {
  width: 342px;
}

.input {
  padding-left: 20px;
  width: 342px;
  height: 60px;
  background: #f4f4f4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  label {
    padding-top: 8px;
    margin-left: 5px;
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #959595;
  }

  input {
    width: 280px;
    height: 22px;
    border: none;
    background-color: #f4f4f4;
    padding-bottom: 5px;
    padding-top: 0;
    margin-top: 8px;
    margin-left: -5px;

    &:focus {
      box-shadow: none !important;
    }
  }
}

#notification-container {
  h2 {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: #252733;
  }

  h3 {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: #252733;
  }
}

#notification {
  input {
    text-align: start;
    width: 642px;
    padding-bottom: 80px;
    background: #f4f4f4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #161616;
  }

  &:focus {
    box-shadow: none;
  }
}

#support-container {
  h2 {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: #252733;
  }

  h3 {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: #252733;
  }
}

#save-button {
  width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/SettingsPage.vue